import React from 'react';

import Typography from 'components/ui/Typography';

import css from './Label.module.scss';

interface Props extends React.PropsWithChildren {
    text: string;
}

const Label: React.FC<Props> = ({ text, children }) => (
    <label className={css.label}>
        <div className={css.container}>
            <Typography color="gray2">{text}</Typography>
        </div>
        {children}
    </label>
);

export default React.memo(Label);
